import { render, staticRenderFns } from "./KpiCard.vue?vue&type=template&id=3c017f5c&scoped=true&"
import script from "./KpiCard.vue?vue&type=script&lang=ts&"
export * from "./KpiCard.vue?vue&type=script&lang=ts&"
import style0 from "./KpiCard.vue?vue&type=style&index=0&id=3c017f5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c017f5c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
